import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=2a98c92e&scoped=true&"
import script from "./InputError.vue?vue&type=script&lang=js&"
export * from "./InputError.vue?vue&type=script&lang=js&"
import style0 from "./InputError.vue?vue&type=style&index=0&id=2a98c92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98c92e",
  null
  
)

export default component.exports